module.exports = __webpack_public_path__ + "img/toolImg.a43caf1a.png";